module.exports = __webpack_public_path__ + "img/reservation-coupon.8ba48a95.svg";